import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import Icon from '../../../base/icons/components/Icon';
import { IconZoom } from '../../../base/icons/svg';
import { inklusivaContextMenuStyles } from '../../../inklusiva/ui-constants';
import { ZOOM_SLIDER_MAXIMUM, ZOOM_SLIDER_MINIMUM } from '../../constants';
const useStyles = makeStyles()(theme => {
    return {
        ...inklusivaContextMenuStyles(theme)
    };
});
const _onClick = (e) => {
    e.stopPropagation();
};
const ZoomSlider = ({ initialValue, label, onChange }) => {
    const { classes, cx } = useStyles();
    const { t } = useTranslation();
    const [zoomLevel, setZoomLevel] = useState(initialValue || 1);
    const _onZoomLevelChange = useCallback((event) => {
        const newZoomLevel = Number(event.currentTarget.value);
        onChange(newZoomLevel);
        setZoomLevel(newZoomLevel);
    }, [onChange]);
    return (React.createElement("div", { "aria-label": t('zoomSlider'), className: classes.contextMenuSlider },
        React.createElement("label", { className: classes.contextMenuSliderLabel, htmlFor: 'zoom-slider-input' }, label),
        React.createElement("div", { className: cx('popupmenu__contents', classes.contextMenuSliderInner), onClick: _onClick },
            React.createElement("span", { className: classes.contextMenuSliderIcon },
                React.createElement(Icon, { size: 22, src: IconZoom })),
            React.createElement("input", { "aria-label": label, id: 'zoom-slider-input', "aria-valuemax": ZOOM_SLIDER_MAXIMUM, "aria-valuemin": ZOOM_SLIDER_MINIMUM, "aria-valuenow": zoomLevel, max: ZOOM_SLIDER_MAXIMUM, min: ZOOM_SLIDER_MINIMUM, onChange: _onZoomLevelChange, tabIndex: 0, type: 'range', value: zoomLevel }))));
};
export default ZoomSlider;
